import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { clientesColumns } from './columns/_columns'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { EmpresaList } from '../../empresas-list/core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

export const ClientesTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { filters, setFilter } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => clientesColumns(t), [t])

  // Sem instituição não há o que listar; com filtro de situação, oferece limpar; senão, vazio.
  const emptyState = !filters.empresa ? (
    <TableEmptyState
      title={`Selecione uma ${t('empresa.label.lowercase')}`}
      description={`As ${t('entidade.plural.lowercase')} são listadas por ${t(
        'empresa.label.lowercase'
      )}. Escolha uma no filtro acima.`}
    />
  ) : filters.status ? (
    <TableEmptyState
      title={`Nenhuma ${t('entidade.label.lowercase')} com essa situação`}
      description='Revise a situação selecionada.'
      action={{ label: 'Limpar situação', onClick: () => setFilter('status', undefined) }}
    />
  ) : (
    <TableEmptyState
      title={`Nenhuma ${t('entidade.label.lowercase')} cadastrada`}
      description={`Esta ${t('empresa.label.lowercase')} ainda não tem ${t(
        'entidade.plural.lowercase'
      )}. Use “Adicionar” para cadastrar a primeira.`}
    />
  )

  return (
    <CustomTable<EmpresaList>
      id='kt_table_clientes'
      ariaLabel={t('entidade.plural')}
      itemLabel={{
        singular: t('entidade.label.lowercase'),
        plural: t('entidade.plural.lowercase'),
      }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
